import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {columns, MAATS, requiredTypesWhenKozijnMontage, requiredTypesWhenOpgeklampt, titles} from "../SituationPick";

SituatieEind.propTypes = {
    canAddRow: PropTypes.bool.isRequired,
    nextRow: PropTypes.func.isRequired,
    currentRow: PropTypes.number.isRequired,
    totalRows: PropTypes.number.isRequired,
    data: PropTypes.array.isRequired,
    isMuurMontage: PropTypes.bool.isRequired,
    isOpgeklampt: PropTypes.bool.isRequired,
}

export default function SituatieEind(props) {
    return <div className="phone-page-middle">
        <div className="phone-situation-title">
            U heeft deze situatie ingevuld.<br/>
            <br/>
            {props.currentRow + 1 < props.totalRows
                ? <>U heeft {props.totalRows} situaties in totaal. <a onClick={props.nextRow}>Doorgaan naar
                    situatie {props.currentRow + 2}?</a></>
                : (props.canAddRow
                        ? <>Heeft u nog een situatie?<br/><a onClick={props.nextRow}>Klik dan hier</a></>
                        : <>U heeft het maximaal aantal situaties berijkt.</>
                )
            }
            <br/>
            <br/>
            <table>
                <tbody>
                {columns.map((column, i) => {
                    if (requiredTypesWhenKozijnMontage.includes(column) && props.isMuurMontage) return null;
                    if (requiredTypesWhenOpgeklampt.includes(column) && props.isOpgeklampt) return null;
                    if (MAATS === column && props.currentRow !== 0) return null;
                    return <tr key={column}>
                        <td>{titles[i]}:</td>
                        <td>{props.data[props.currentRow][column]}</td>
                    </tr>
                })}
                </tbody>
            </table>
        </div>
    </div>;
}
